import { useCallback } from 'react'

import { logError } from '@sequencehq/utils'

import { ServerAsset } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

type ErrorResponse = { error: { errors: { message: string }[] } }

export const useUploadAssets = () => {
  return useCallback(
    async ({
      files,
      onUploadSuccess,
      onUploadFailure
    }: {
      files: File[]
      onUploadSuccess: (asset: ServerAsset) => void | Promise<void>
      onUploadFailure?: (error: string) => void
    }) => {
      return await Promise.all(
        files.map(async file => {
          try {
            const res = await uploadAsset(file)

            if (!res.data) {
              const errorResponse: ErrorResponse = await res.res.json()

              onUploadFailure?.(
                errorResponse.error.errors?.[0]?.message ??
                  'Something went wrong.'
              )

              return
            }

            await onUploadSuccess(res.data)

            return res.data
          } catch (e) {
            logError(e)
          }
        })
      )
    },
    []
  )
}

const uploadAsset = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  return await dashboard20240730Client.postAssets({
    formData
  })
}
